/* eslint-disable no-useless-catch */
import { API } from "../api";

export const GET_ALL = "GET_ALL";

export const getAllLogs = (url, data = {}) => {
  return async (dispatch) => {
    try {
      const res = await API.post(url, data);
      if (Object.keys(data).length) {
        dispatch({
          type: GET_ALL,
          payload: res
        });
      }
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export default function reducer(
  state = { rows: [], count: 0 },
  { type, payload }
) {
  switch (type) {
    case GET_ALL:
      return {
        ...state,
        columns: payload.columns,
        rows: payload.rows,
        count: payload.count
      };
    default:
      return state;
  }
}
